import Vue from 'vue'
import App from './App.vue'
import dataV from '@jiaminghi/data-view'
import * as echarts from 'echarts'

Vue.config.productionTip = false

// 注册 DataV 组件
Vue.use(dataV)

// 将 echarts 挂载到 Vue 原型上
Vue.prototype.$echarts = echarts

new Vue({
  render: h => h(App),
}).$mount('#app')
